module.exports = __webpack_public_path__ + "static/group-47-faa5bc5c0ceb1fa074a612360b3d3f9a.svg";